import { render, staticRenderFns } from "./dialogEditDonors.vue?vue&type=template&id=694ad56e"
import script from "./dialogEditDonors.vue?vue&type=script&lang=js"
export * from "./dialogEditDonors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports